export default {
  REDIRECT_TITLE_SEPARATOR: '→',
};
